<template>
  <div id="comment-after">
    <div class="lv0Text t">
      <i class="far fa-check-circle fa-2x" style="margin-right:20px"></i>
      <span>评价完成！</span>
      <div class="lv2Text back">
        返回
        <router-link to="/user/orders/1">我的订单</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
    };
  },
  watch: {},
  created() {
    //
    this.$store.state.user_location = "我的订单";
    this.$store.state.user_location2 = "评价晒单";
    this.$store.state.leftMenuIndex = 12;
    this.initData();
  },
  methods: {
    //
    initData() {}
  }
};
</script>
<style lang="scss">
#comment-after {
  .t {
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    padding: 60px 0;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .fa-check-circle {
    position: relative;
    top: 10px;
  }
  .back {
    font-size: 14px;
    font-weight: normal;
    margin-top: 40px;
    a:hover {
      color: #e2211c;
      text-decoration: underline;
    }
  }
}
</style>